module.exports = __webpack_public_path__ + "img/heart.757bfdc4.svg";